export const PAYMENT_LINKS_ALLOWED_CURRENCIES_BY_COUNTRY: Record<string, readonly string[]> = {
  CO: ['COP'],
  CL: ['CLP'],
};

export const PAYMENT_LINKS_DEFAULT_CURRENCIES: readonly string[] = [];
